import { render, staticRenderFns } from "./buttonComponent.vue?vue&type=template&id=b17e2d88&"
import script from "./buttonComponent.vue?vue&type=script&lang=js&"
export * from "./buttonComponent.vue?vue&type=script&lang=js&"
import style0 from "./buttonComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b17e2d88')) {
      api.createRecord('b17e2d88', component.options)
    } else {
      api.reload('b17e2d88', component.options)
    }
    module.hot.accept("./buttonComponent.vue?vue&type=template&id=b17e2d88&", function () {
      api.rerender('b17e2d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/button/buttonComponent.vue"
export default component.exports